module.exports = __webpack_public_path__ + "static/media/KN3@2x.da76b946.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/KN/KN3@2x.png
// module id = 667
// module chunks = 0